import { far } from "@fortawesome/free-regular-svg-icons";
import { useCreateBioFlocsMutation } from "./api";
import CryptoJS from "crypto-js";
const secretKey = '3xA6QlyA_4f]My47)IUm-wG({t")a$';

export const getTokenFromLocalStorage = () => {
  try {
    const encrypted = localStorage.getItem("token");
    if (!encrypted) return null;

    const bytes = CryptoJS.AES.decrypt(encrypted, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    return decrypted; // since you JSON.stringify(token) before saving
  } catch (err) {
    console.error("Token decryption failed:", err);
    return null;
  }
};

export const endpoints = (builder) => ({
  // GET ALL TABLE RECORDS
  getAllTableRecords: builder.query({
    query: (id) => ({
      url: `table/all`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
      params: { district_id: id },
    }),
    providesTags: ["GET_ALL_TABLE_RECORDS"],
  }),

  // Dashboard Farmer Scheme INTEREST
  getAllSchemeInterest: builder.query({
    query: () => ({
      url: `dashboard/scheme-interest`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_SCHEME_INTEREST"],
  }),

  loginUser: builder.mutation({
    invalidatesTags: ["ME"],
    query: (payload) => ({
      url: `user/login`,
      method: "post",
      body: payload,
    }),
    providesTags: ["LOGIN_USER"],
  }),

  // ME
  me: builder.query({
    query: () => ({
      url: `dashboard/me`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["ME"],
  }),

  getRoleByDesignation: builder.query({
    query: (body) => ({
      url: `/role/role-list?designation_level=${body.designation_level}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ROLE_BY_DESIGNATION "],
  }),

  getPmKisanData: builder.query({
    query: (args) => ({
      url: "pm-kisan/list",
      method: "get",
      params: { ...args },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_PM_KISAN_DATA"],
  }),
  singlePmKisanData: builder.query({
    query: ({ id }) => ({
      url: `pm-kisan/view?id=${id}`,
      method: "get",
      // params: {...args},
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_PM_KISAN_DATA"],
  }),

  getDistrictList: builder.query({
    query: () => ({
      url: "district/list",
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_DISTRICT_LIST"],
  }),

  getRdBlockList: builder.query({
    query: (params) => ({
      url: "rd-block/list",
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_RD_BLOCK_LIST"],
  }),

  getGramPanchayatList: builder.query({
    query: (params) => ({
      url: `gram-panchayat/gp-list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_GRAM_PANCHAYAT_LIST"],
  }),
  getSsoData: builder.mutation({
    query: (params) => ({
      url: `sso/token`,
      method: "post",
      body: params,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_Sso_Data"],
  }),

  getWeatherStationList: builder.query({
    query: (params) => ({
      url: "weather-station/",
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["WEATHER_STATION_LIST"],
  }),
  getSingleWeatherStation: builder.query({
    query: (params) => ({
      url: `weather-station/${params.id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["WEATHER_STATION_SINGLE"],
  }),

  createWeatherStation: builder.mutation({
    invalidatesTags: ["WEATHER_STATION_LIST"],
    query: (body) => ({
      url: "weather-station/",
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["WEATHER_STATION_CREATE"],
  }),

  updateWeatherStation: builder.mutation({
    invalidatesTags: ["WEATHER_STATION_LIST"],
    query: (body) => ({
      url: `weather-station/${body.id}`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["WEATHER_STATION_UPDATE"],
  }),

  gethWeatherDataList: builder.query({
    // invalidatesTags : ['REFRESH_STATION_DATA'],
    query: (params) => ({
      url: `weather/`,
      method: "get",
      params,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
      providesTags: ["STATION_DATA_LIST"],
    }),
  }),

  refreshWeatherData: builder.mutation({
    invalidatesTags: ["STATION_DATA_LIST"],
    query: (body) => ({
      url: `weather/refresh`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["STATION_DATA_REFRESH"],
  }),

  getAllWeatherDataList: builder.query({
    invalidatesTags: ["STATION_DATA_LIST"],
    query: () => ({
      url: `weather/all`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["STATION_DATA_ALL_LIST"],
  }),

  getAllDesignationList: builder.query({
    query: (params) => ({
      url: `designation/`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["DESIGNATION_DATA_LIST"],
  }),

  getSingleDesignation: builder.query({
    query: (id) => ({
      url: `designation/${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["DESIGNATION_DATA_SINGLE"],
  }),

  getAllUser: builder.query({
    query: () => ({
      url: `user/list`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_USER"],
  }),

  getAllSdsco: builder.query({
    query: (params) => ({
      url: `sdsco`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_SDSCO"],
  }),

  createSdsco: builder.mutation({
    invalidatesTags: ["GET_ALL_SDSCO"],
    query: (body) => ({
      url: `sdsco`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["CREATE_SDSCO"],
  }),

  getSingleSdsco: builder.query({
    query: (id) => ({
      url: `sdsco/${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SINGLE_SDSCO"],
  }),
  updateSdsco: builder.mutation({
    invalidatesTags: ["GET_ALL_SDSCO"],
    query: (body) => ({
      url: `sdsco/${body.id}`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_SDSCO"],
  }),

  // SOIL SECTION
  getAllSoilSection: builder.query({
    query: (params) => ({
      url: `soil-section`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_SOIL_SECTION"],
  }),
  createSoilSection: builder.mutation({
    invalidatesTags: ["GET_ALL_SOIL_SECTION"],
    query: (body) => ({
      url: `soil-section`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["CREATE_SOIL_SECTION"],
  }),
  getSingleSoilSection: builder.query({
    query: (id) => ({
      url: `soil-section/${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SINGLE_SOIL_SECTION"],
  }),
  updateSoilSection: builder.mutation({
    invalidatesTags: ["GET_ALL_SOIL_SECTION"],
    query: (body) => ({
      url: `soil-section/${body.id}`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_SINGLE_SOIL_SECTION"],
  }),

  // CROP ADVISORY
  getAllCropMaster: builder.query({
    query: (params) => ({
      url: `crop-master/crop-list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CROP_MASTER"],
  }),

  // CROP ADVISORY
  getAllCropAdvisory: builder.query({
    query: (params) => ({
      url: `crop-advisory/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CROP_ADVISORY"],
  }),

  createCropAdvisory: builder.mutation({
    invalidatesTags: ["GET_ALL_SOIL_SECTION"],
    query: (body) => ({
      url: `crop-advisory/create`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["CREATE_CROP_ADVISORY"],
  }),
  getSingleCropAdvisory: builder.query({
    query: (id) => ({
      url: `crop-advisory/view/?id=${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SINGLE_CROP_ADVISORY"],
  }),
  updateCropAdvisory: builder.mutation({
    invalidatesTags: ["GET_ALL_CROP_ADVISORY"],
    query: (body) => ({
      url: `crop-advisory/update`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_SINGLE_CROP_ADVISORY"],
  }),

  // FARMER INTEREST
  getAllFarmerInterest: builder.query({
    query: (params) => ({
      url: `farmer-interest`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_FARMER_INTEREST"],
  }),

  // GRIEVANCE
  updateGrievance: builder.mutation({
    invalidatesTags: ["GET_ALL_GRIEVANCE"],
    query: (body) => ({
      url: `grievance`,
      method: "put",
      body: body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_GRIEVANCE"],
  }),

  getAllGrievanceList: builder.query({
    query: (params) => ({
      url: `grievance/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_GRIEVANCE"],
  }),

  // CREATOR
  getAllCreatorList: builder.query({
    query: (params) => ({
      url: `creator/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CREATOR"],
  }),


  // Upcoming Training Count
  getUpcomingTrainingList: builder.query({
    query: (params) => ({
      url: `creator/upcomingTrainingCount`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CREATOR"],
  }),

  // Completed Training Count
  getCompletedTrainingList: builder.query({
    query: (params) => ({
      url: `creator/completedTrainings`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CREATOR"],
  }),


  createCreator: builder.mutation({
    invalidatesTags: ["GET_ALL_CREATOR"],
    query: (body) => ({
      url: `creator/create`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["CREATE_CREATOR"],
  }),

  updateCreator: builder.mutation({
    invalidatesTags: ["GET_ALL_CREATOR"],
    query: (body) => ({
      url: `creator/update`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_CREATOR"],
  }),

  getSingleCreator: builder.query({
    query: (id) => ({
      url: `creator/view/?id=${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SINGLE_CREATOR"],
  }),
  updateUser: builder.mutation({
    invalidatesTags: ["ME"],
    query: (body) => ({
      url: "user/update-user",
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_USER"],
  }),

  resetPassword: builder.mutation({
    query: (body) => ({
      url: "user/reset-password",
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["RESET_PASSWORD"],
  }),

  userDetails: builder.mutation({
    // invalidatesTags: [ 'ME' ],
    query: (body) => ({
      url: "user/user-details",
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["USER_DETAILS"],
  }),

  getUserDetails: builder.query({
    // invalidatesTags: [ 'ME' ],
    query: (params) => ({
      url: "user/user-details",
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_USER_DETAILS"],
  }),

  userTypeDetails: builder.query({
    // invalidatesTags: [ 'ME' ],
    query: (params) => ({
      url: "user/user-type",
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["USER_TYPE_DETAILS"],
  }),

  // ME
  me: builder.query({
    query: () => ({
      url: `dashboard/me`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["ME"],
  }),

  getRoleByDesignation: builder.query({
    query: (body) => ({
      url: `/role/role-list?designation_level=${body.designation_level}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ROLE_BY_DESIGNATION "],
  }),

  getPmKisanData: builder.query({
    query: (args) => ({
      url: "pm-kisan/list",
      method: "get",
      params: { ...args },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_PM_KISAN_DATA"],
  }),
  singlePmKisanData: builder.query({
    query: ({ id }) => ({
      url: `pm-kisan/view?id=${id}`,
      method: "get",
      // params: {...args},
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_PM_KISAN_DATA"],
  }),

  getDistrictList: builder.query({
    query: () => ({
      url: "district/list",
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_DISTRICT_LIST"],
  }),

  getRdBlockList: builder.query({
    query: (params) => ({
      url: "rd-block/list",
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_RD_BLOCK_LIST"],
  }),

  getGramPanchayatList: builder.query({
    query: (params) => ({
      url: `gram-panchayat/gp-list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_GRAM_PANCHAYAT_LIST"],
  }),
  getSsoData: builder.mutation({
    query: (params) => ({
      url: `sso/token`,
      method: "post",
      body: params,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_Sso_Data"],
  }),

  getWeatherStationList: builder.query({
    query: (params) => ({
      url: "weather-station/",
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["WEATHER_STATION_LIST"],
  }),
  getSingleWeatherStation: builder.query({
    query: (params) => ({
      url: `weather-station/${params.id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["WEATHER_STATION_SINGLE"],
  }),
  // createWeatherStation: builder.mutation({
  //   invalidatesTags: ['WEATHER_STATION_LIST'],
  //   query: (body) => ({
  //     url: "weather-station/",
  //     method: 'post',
  //     body,
  //     headers: {
  //       Authorization: `Bearer ${getTokenFromLocalStorage()}`,
  //     },
  //   }),
  //   providesTags: ['WEATHER_STATION_CREATE']
  // }),
  updateWeatherStation: builder.mutation({
    invalidatesTags: ["WEATHER_STATION_LIST"],
    query: (body) => ({
      url: `weather-station/${body.id}`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["WEATHER_STATION_UPDATE"],
  }),

  refreshWeatherData: builder.mutation({
    invalidatesTags: ["STATION_DATA_LIST"],
    query: (body) => ({
      url: `weather/refresh`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["STATION_DATA_REFRESH"],
  }),

  getAllWeatherDataList: builder.query({
    invalidatesTags: ["`STATION_DATA_LIST`"],
    query: () => ({
      url: `weather/all`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["STATION_DATA_ALL_LIST"],
  }),

  gethWeatherDataList: builder.query({
    // invalidatesTags : ['REFRESH_STATION_DATA'],
    query: (params) => ({
      url: `weather/`,
      method: "get",
      params,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["STATION_DATA_LIST"],
  }),

  /* CITY WEATHER API */

  refreshCityWeather: builder.mutation({
    invalidatesTags: ["GET_CITY_WEATHER_LIST"],
    query: (params) => ({
      url: `weather/all/city-weather`,
      method: "post",
      params,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["REFRESH_CITY_WEATHER"],
  }),

  refreshSingleCityWeather: builder.mutation({
    invalidatesTags: ["GET_CITY_WEATHER_LIST"],
    query: (body) => ({
      url: `weather/city-weather/refresh`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),

    providesTags: ["REFRESH_SINGLE_CITY_WEATHER"],
  }),

  getCityWeatherList: builder.query({
    invalidatesTags: ["GET_CITY_WEATHER_LIST"],
    query: (params) => ({
      url: `weather/city-weather`,
      method: "get",
      params,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_CITY_WEATHER_LIST"],
  }),

  getAllDesignationList: builder.query({
    query: (params) => ({
      url: `designation/`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["DESIGNATION_DATA_LIST"],
  }),

  getSingleDesignation: builder.query({
    query: (id) => ({
      url: `designation/${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["DESIGNATION_DATA_SINGLE"],
  }),

  getAllUser: builder.query({
    query: () => ({
      url: `user/list`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_USER"],
  }),

  getAllSdsco: builder.query({
    query: (params) => ({
      url: `sdsco`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_SDSCO"],
  }),

  createSdsco: builder.mutation({
    invalidatesTags: ["GET_ALL_SDSCO"],
    query: (body) => ({
      url: `sdsco`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["CREATE_SDSCO"],
  }),

  getSingleSdsco: builder.query({
    query: (id) => ({
      url: `sdsco/${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SINGLE_SDSCO"],
  }),
  updateSdsco: builder.mutation({
    invalidatesTags: ["GET_ALL_SDSCO"],
    query: (body) => ({
      url: `sdsco/${body.id}`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_SDSCO"],
  }),

  // SOIL SECTION
  getAllSoilSection: builder.query({
    query: (params) => ({
      url: `soil-section`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_SOIL_SECTION"],
  }),
  createSoilSection: builder.mutation({
    invalidatesTags: ["GET_ALL_SOIL_SECTION"],
    query: (body) => ({
      url: `soil-section`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["CREATE_SOIL_SECTION"],
  }),
  getSingleSoilSection: builder.query({
    query: (id) => ({
      url: `soil-section/${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SINGLE_SOIL_SECTION"],
  }),
  updateSoilSection: builder.mutation({
    invalidatesTags: ["GET_ALL_SOIL_SECTION"],
    query: (body) => ({
      url: `soil-section/${body.id}`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_SINGLE_SOIL_SECTION"],
  }),

  // CROP ADVISORY
  getAllCropMaster: builder.query({
    query: (params) => ({
      url: `crop-master/crop-list`,
      method: "get",
      // params: {...params},
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CROP_MASTER"],
  }),

  // CROP ADVISORY
  getAllCropAdvisory: builder.query({
    query: (params) => ({
      url: `crop-advisory/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CROP_ADVISORY"],
  }),

  createCropAdvisory: builder.mutation({
    invalidatesTags: ["GET_ALL_SOIL_SECTION"],
    query: (body) => ({
      url: `crop-advisory/create`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["CREATE_CROP_ADVISORY"],
  }),
  getSingleCropAdvisory: builder.query({
    query: (id) => ({
      url: `crop-advisory/view/?id=${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SINGLE_CROP_ADVISORY"],
  }),
  updateCropAdvisory: builder.mutation({
    invalidatesTags: ["GET_ALL_CROP_ADVISORY"],
    query: (body) => ({
      url: `crop-advisory/update`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_SINGLE_CROP_ADVISORY"],
  }),

  // FARMER INTEREST
  getAllFarmerInterest: builder.query({
    query: (params) => ({
      url: `farmer-interest`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_FARMER_INTEREST"],
  }),

  // GRIEVANCE
  updateGrievance: builder.mutation({
    invalidatesTags: ["GET_ALL_GRIEVANCE"],
    query: (body) => ({
      url: `grievance`,
      method: "put",
      body: body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_GRIEVANCE"],
  }),

  getAllGrievanceList: builder.query({
    query: (params) => ({
      url: `grievance/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_GRIEVANCE"],
  }),

  // CREATOR
  getAllCreatorList: builder.query({
    query: (params) => ({
      url: `creator/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CREATOR"],
  }),

  createCreator: builder.mutation({
    invalidatesTags: ["GET_ALL_CREATOR"],
    query: (body) => ({
      url: `creator/create`,
      method: "post",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["CREATE_CREATOR"],
  }),

  updateCreator: builder.mutation({
    invalidatesTags: ["GET_ALL_CREATOR"],
    query: (body) => ({
      url: `creator/update`,
      method: "put",
      body,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["UPDATE_CREATOR"],
  }),

  getSingleCreator: builder.query({
    query: (id) => ({
      url: `creator/view/?id=${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SINGLE_CREATOR"],
  }),

  getReviewLogs: builder.query({
    query: ({ id, district_id }) => ({
      url: `creator/logs`,
      method: "get",
      params: { id, district_id },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_REVIEW_LOG"],
  }),

  getAllSchemeMasterList: builder.query({
    query: (params) => ({
      url: `scheme-master/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_SCHEME_LIST"],
  }),

  getAllCropDiseaseLogList: builder.query({
    query: (params) => ({
      url: `crop-disease/logs`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_CROP_DISEASE_LOG"],
  }),

  getAllFarmerList: builder.query({
    query: (params) => ({
      url: `farmer`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_FARMER_LIST"],
  }),

  /*AGRI STACK*/
  getOwnerCodeDetails: builder.mutation({
    query: (body) => ({
      url: `agri-stack/agristackhp-village`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_OWNER_CODE"],
  }),

  getLandDetails: builder.mutation({
    query: (body) => ({
      url: `agri-stack/agristackhp-vill-owner`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_LAND_LIST"],
  }),
  /*END HERE*/

  /*Village*/
  getVillageList: builder.query({
    query: (params) => ({
      url: `village/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_VILLAGE_LIST"],
  }),
  createBioFlocs: builder.mutation({
    query: (body) => ({
      url: `/bioflocs/create`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["POST_BIO_FLOCS"],
  }),
  updateBioFlocs: builder.mutation({
    query: (body) => ({
      url: `/bioflocs/updateBiofloc`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["PUT_BIO_FLOCS"],
  }),
  getBioFlocList: builder.query({
    query: (params) => ({
      url: `bioflocs/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_VILLAGE_LIST"],
  }),

  createVehicle: builder.mutation({
    query: (body) => ({
      url: `/vehicles/create`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["POST_BIO_FLOCS"],
  }),
  updateVehicle: builder.mutation({
    query: (body) => ({
      url: `/vehicles/updateVehicle`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["PUT_BIO_FLOCS"],
  }),
  getVehicleList: builder.query({
    query: (params) => ({
      url: `vehicles/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_VILLAGE_LIST"],
  }),

  // =========================crud panchayat pond+++++++++++++++++++++++++++++++++++================
  createPonds: builder.mutation({
    query: (body) => ({
      url: `/ponds/create`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["POST_Pachayatpounds"],
  }),

  editPonds: builder.query({
    query: (params) => ({
      url: `/ponds/editPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_editPonds"],
  }),
  updatePonds: builder.mutation({
    query: (body) => ({
      url: `/ponds/updatePond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["PUT_BIO_FLOCS"],
  }),
  getPondsList: builder.query({
    query: (params) => ({
      url: `/ponds/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_VILLAGE_LIST"],
  }),

  getHrBlocksList: builder.query({
    query: (params) => ({
      url: `/block/blocksDistrictWiseList?district_id=${params?.district}`,
      method: "get",
      // params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ALL_DISTRICT_LIST"],
  }),
  getHrVillagesList: builder.query({
    query: (params) => ({
      url: `/village/villageList`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),
  getSchemeList: builder.query({
    query: (params) => ({
      url: `scheme-master/schemeMasterListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),
  getFarmersList: builder.query({
    query: ({ id }) => ({
      url: `/farmer/listing?district_id=${id}`,
      method: "get",
      // params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),
  /*END HERE*/

  // ========================For Lease api===========================
  getLeaseList: builder.query({
    query: (params) => ({
      url: `/ponds/leaseListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_Lease_Listing"],
  }),

  createLease: builder.mutation({
    query: (body) => ({
      url: `/ponds/leaseCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_Lease_Listing"],
  }),
  getSingleLease: builder.query({
    query: (params) => ({
      url: `/ponds/editLease`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_SinGle_Lease_LIST"],
  }),
  postLease: builder.mutation({
    query: (body) => ({
      url: `ponds/updateLease`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_Lease_Listing"],
  }),

  getCultureList: builder.query({
    query: (params) => ({
      url: `/ponds/cultureListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_CultureList"],
  }),
  getSepCultureListBioFloc: builder.query({
    query: (params) => ({
      url: `ponds/bioflocCultureListing`,
      // http://localhost:8000/api/ponds/bioflocCultureListing?district_id=8&page_number=1&page_size=10&biofloc_culture_bioflocid=23

      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_CultureList_BioFloc"],
  }),

  createCulture: builder.mutation({
    query: (body) => ({
      url: `/ponds/cultureCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_CultureList"],
  }),

  createCultureBioFloc: builder.mutation({
    query: (body) => ({
      url: `/ponds/bioflocCultureCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_CultureList_BioFloc"],
  }),
  updateCulture: builder.mutation({
    query: (body) => ({
      url: `/ponds/updateCulture`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_CultureList"],
  }),
  updateCultureBioFloc: builder.mutation({
    query: (body) => ({
      url: `/ponds/bioflocUpdateCulture`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_CultureList"],
  }),

  getFishVarietyList: builder.query({
    query: (params) => ({
      url: `/crop-master/fishVarietyListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),

  getSingleCulture: builder.query({
    query: (params) => ({
      url: `/ponds/editCulture`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_CultureList"],
  }),
  getSingleCultureBioFloc: builder.query({
    query: (params) => ({
      url: `/ponds/bioflocEditCulture`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_CultureList_BioFloc"],
  }),

  // ========================For FishProductionList===========================
  getFishProductionList: builder.query({
    query: (params) => ({
      url: `/ponds/fishProductionListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_FishProductionList"],
  }),
  getFishProductionListBioFloc: builder.query({
    query: (params) => ({
      url: `/ponds/bioflocFishProductionListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_FishProductionList_BP"],
  }),

  createFishProduction: builder.mutation({
    query: (body) => ({
      url: `/ponds/fishProductionCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_FishProductionList"],
  }),

  createFishProductionBioFloc: builder.mutation({
    query: (body) => ({
      url: `/ponds/bioflocFishProductionCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_FishProductionList_BP"],
  }),

  updateFishProduction: builder.mutation({
    query: (body) => ({
      url: `/ponds/updateFishProduction`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_FishProductionList"],
  }),
  updateFishProductionBioFloc: builder.mutation({
    query: (body) => ({
      url: `/ponds/updateBioflocFishProduction`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_FishProductionList_BF"],
  }),

  getFishVarietyList: builder.query({
    query: (params) => ({
      url: `/crop-master/fishVarietyListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),

  getSingleFishProduction: builder.query({
    query: (params) => ({
      url: `/ponds/editFishProduction`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),

  getSingleFishProductionBioFloc: builder.query({
    query: (params) => ({
      url: `/ponds/editBioflocFishProduction`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST_Bio_Floc"],
  }),

  // ========================For farmer detail data here===========================
  // /farmer/fetchFarmerDetails?farmer_id=8

  getSingleFarmerDetail: builder.query({
    query: (params) => ({
      url: `/farmer/fetchFarmerDetails`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),

  // ================Reno api'sation here===========================

  getRenovationList: builder.query({
    query: (params) => ({
      url: `ponds/renovationOfPondListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_RenovationList"],
  }),

  createRenovation: builder.mutation({
    query: (body) => ({
      url: `/ponds/renovationOfPondCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_RenovationList"],
  }),
  updateRenovation: builder.mutation({
    query: (body) => ({
      url: `/ponds/updaterenovationOfPond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_RenovationList"],
  }),

  getSingleRenovation: builder.query({
    query: (params) => ({
      url: `/ponds/editrenovationOfPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),

  // ================SSS api'sation here===========================

  getSSSList: builder.query({
    query: (params) => ({
      url: `/ponds/sssPondListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),

  createSSS: builder.mutation({
    query: (body) => ({
      url: `/ponds/sssPondCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_SSSList"],
  }),
  updateSSS: builder.mutation({
    query: (body) => ({
      url: `/ponds/updatesssPond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_SSSList"],
  }),

  getSingleSSS: builder.query({
    query: (params) => ({
      url: `/ponds/editsssPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),
  // ================IP api'sation here===========================

  getIPList: builder.query({
    query: (params) => ({
      url: `/ponds/ipPondListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),

  createIP: builder.mutation({
    query: (body) => ({
      url: `/ponds/ipPondCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_IPList"],
  }),
  updateIP: builder.mutation({
    query: (body) => ({
      url: `/ponds/updateipPond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_IPList"],
  }),

  getSingleIP: builder.query({
    query: (params) => ({
      url: `/ponds/editipPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),
  // ================SOI api'sation here===========================

  getSOIList: builder.query({
    query: (params) => ({
      url: `/ponds/soiPondListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),

  createSOI: builder.mutation({
    query: (body) => ({
      url: `/ponds/soiPondCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_SIOList"],
  }),
  updateSOI: builder.mutation({
    query: (body) => ({
      url: `/ponds/updatesoiPond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_SIOList"],
  }),

  getSingleSOI: builder.query({
    query: (params) => ({
      url: `/ponds/editsoiPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_VILLAGE_LIST"],
  }),
  // ================FSS api'sation here===========================

  getFSSList: builder.query({
    query: (params) => ({
      url: `/ponds/fssPondListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_FSS_LIST"],
  }),

  createFSS: builder.mutation({
    query: (body) => ({
      url: `/ponds/fssPondCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_FSS_LIST"],
  }),
  updateFSS: builder.mutation({
    query: (body) => ({
      url: `/ponds/updatefssPond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_FSS_LIST"],
  }),

  getSingleFSS: builder.query({
    query: (params) => ({
      url: `/ponds/editfssPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_FSS_SINGLE"],
  }),
  // ================KCC api'sation here===========================

  getKCCList: builder.query({
    query: (params) => ({
      url: `/ponds/kccPondListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_KCC_LIST"],
  }),

  createKCC: builder.mutation({
    query: (body) => ({
      url: `/ponds/kccPondCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_KCC_LIST"],
  }),
  updateKCC: builder.mutation({
    query: (body) => ({
      url: `/ponds/updatekccPond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_KCC_LIST"],
  }),

  getSingleKCC: builder.query({
    query: (params) => ({
      url: `/ponds/editkccPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_KCC_SINGLE"],
  }),

  // ================Notified Area api'sation here===========================
  getNotifiedList: builder.query({
    query: (params) => ({
      url: `/notifiedareas/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_NOTI_LIST"],
  }),

  createNotified: builder.mutation({
    query: (body) => ({
      url: `/notifiedareas/create`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_NOTI_LIST"],
  }),
  updateNotified: builder.mutation({
    query: (body) => ({
      url: `notifiedareas/updateNA`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_NOTI_LIST"],
  }),

  getSingleNotified: builder.query({
    query: (params) => ({
      url: `/notifiedareas/editNAEntry`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_NOTI_SINGLE"],
  }),
  // ==============================Pvt ponds api===================================
  getPvtPondsList: builder.query({
    query: (params) => ({
      url: `/ponds/listPrivatePond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["PVT_POND_LIST"],
  }),

  createPvtPonds: builder.mutation({
    query: (body) => ({
      url: `/ponds/privateCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_NOTI_LIST"],
  }),
  editPvtPonds: builder.query({
    query: (params) => ({
      url: `/ponds/editPrivatePond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_editPonds"],
  }),
  updatePvtPonds: builder.mutation({
    query: (body) => ({
      url: `/ponds/updatePrivatePond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_NOTI_LIST"],
  }),
  // ==============================LakeReservoirPonds api===================================
  getLakeReservoirPondsList: builder.query({
    query: (params) => ({
      url: `/ponds/listlakeReservoirPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["Lake_POND_LIST"],
  }),
  createlakeReservoirPonds: builder.mutation({
    query: (body) => ({
      url: `/ponds/lakeReservoirCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_NOTI_LIST"],
  }),
  editLakeReservoirPonds: builder.query({
    query: (params) => ({
      url: `/ponds/editlakeReservoirPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_editPonds"],
  }),
  updateLakeReservoirPonds: builder.mutation({
    query: (body) => ({
      url: `/ponds/updatelakeReservoirPond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_NOTI_LIST"],
  }),
  // ==============================WaterShedPonds api===================================
  getWaterShedPondsList: builder.query({
    query: (params) => ({
      url: `/ponds/listwaterShedsPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["Water_Shed_LIST"],
  }),
  createwaterShedsPonds: builder.mutation({
    query: (body) => ({
      url: `/ponds/waterShedsCreate`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_NOTI_LIST"],
  }),
  editWaterShedPonds: builder.query({
    query: (params) => ({
      url: `/ponds/editwaterShedsPond`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_editPonds"],
  }),

  updateWaterShedPonds: builder.mutation({
    query: (body) => ({
      url: `/ponds/updatewaterShedsPond`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_NOTI_LIST"],
  }),

  // ==============================Bank fetch for kcc api===================================
  getBankList: builder.query({
    query: (params) => ({
      url: `ponds/fetchBankDetails`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_BANK_LIST"],
  }),
  // ==============================Farmer MPR ALL Module API===================================
  getMprVehicleList: builder.query({
    query: (params) => ({
      url: `/mprinputs/goButtonListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["Mpr_Vehicle_LIST"],
  }),
  // ==============================Scheme MprList API===================================
  getschemeMprList: builder.query({
    query: (params) => ({
      url: `scheme-master/schemesListingAsPerType`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["Mpr_Scheme_LIST"],
  }),

  createMprBioFloc: builder.mutation({
    query: (body) => ({
      url: `/mprinputs/create`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["Mpr_Create_LIST"],
  }),

  editMprBioFloc: builder.query({
    query: (params) => ({
      url: `/mprinputs/editFarmerAsset`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_EditPonds"],
  }),

  updateMprBioFloc: builder.mutation({
    query: (body) => ({
      url: `/mprinputs/updateFarmerAsset `,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["GET_UpdatePonds"],
  }),

  // ========

  getFarmerList: builder.query({
    query: (params) => ({
      url: `farmer/allFarmersListing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["Farmer"],
  }),

  getFarmerById: builder.query({
    query: (id) => ({
      url: `farmer/editFarmer?id=${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  createFarmer: builder.mutation({
    query: (body) => ({
      url: `farmer/createFarmer`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["Farmer"],
  }),

  updateFarmer: builder.mutation({
    query: (body) => ({
      url: `farmer/updateFarmer`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["Farmer"],
  }),
  updateFarmer: builder.mutation({
    query: (body) => ({
      url: `farmer/updateFarmer`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["Farmer"],
  }),

  downloadFarmerList: builder.query({
    query: (params) => ({
      url: `farmer/exportFarmersToXlsx`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  getPachExportedExcel: builder.query({
    query: (id) => ({
      url: `/ponds/exportPondsToXlsx?p_ownership=1`,
      method: "get",

      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  financialYear: builder.query({
    query: (params) => ({
      url: `finyear/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  listSaralDistSummary: builder.query({
    query: (params) => ({
      url: `ponds/listSaralDistSummary`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  getSaralDashboardRecord: builder.query({
    query: (params) => ({
      url: `ponds/saralDataMonthWiseView`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  getDashboardPieChartData: builder.query({
    query: (params) => ({
      url: `/dashboard/districtwiseOwnershipwisecounts?district=${params?.id}`,
      method: "get",
      // params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),
  getDashboardColChart1Data: builder.query({
    query: (params) => ({
      url: `/dashboard/districtwiseCategorywisecountsofgovtponds?district=${params?.id}`,
      method: "get",
      // params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  getDashboardColChart2Data: builder.query({
    query: (params) => ({
      url: `/dashboard/districtwiseConditionwisecountsofgovtponds?district=${params?.id}`,
      method: "get",
      // params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),
  getSchemewiseSummaryofSaralSanctionsState: builder.query({
    query: (params) => ({
      url: `/ponds/saralSchemewiseSummaryofSaralSanctionsState?finYear=${params?.finYr} `,
      method: "get",
      // params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),
  getSchemewiseSummaryofDistrictWise: builder.query({
    query: (params) => ({
      url: `/ponds/saralSchemewiseSummaryofSaralSanctionsDistrictWise?district_id=${params?.distt}&finYear=${params?.finYr} `,
      method: "get",
      // params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  createStateTargets: builder.mutation({
    query: (body) => ({
      url: `/state_targets/create`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["State_Targets"],
  }),

  getStateTargetList: builder.query({
    query: (params) => ({
      url: `state_targets/list`,
      method: "get",
      params,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),
  editStateTarget: builder.query({
    query: (params) => ({
      url: `state_targets/edit?st_auto_id=${params?.auto_id}&fin_year_id=${params?.fin_year}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),
  getIntensiveList: builder.query({
    query: (params) => ({
      url: `/ponds/districtLevelMPRReport?district=${params?.district}&mthYear=${params?.mth_yr}&report=${params.report}&type=${params.type}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["intensiveFisheriesDevelopment"],
  }),
  updateStateTarget: builder.mutation({
    query: (body) => ({
      url: `/state_targets/update`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["Farmer"],
  }),
  getShowSaralStateList: builder.query({
    query: (params) => ({
      url: `/ponds/saralSchemewiseSummaryofSaralSanctionsStateView`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["saralSchemewiseSummaryofSaralSanctionsStateView"],
  }),
  getShowSaralDisttList: builder.query({
    query: (params) => ({
      url: `/ponds/saralSchemewiseSummaryofSaralSanctionsDistrictWiseView`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["saralSchemewiseSummaryofSaralSanctionsStateView"],
  }),

  getStateAchievementsList: builder.query({
    query: (params) => ({
      url: `/ponds/stateLevelMPRSCWelfareAchievemet`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["stateLevelMPRSCWelfareAchievemet"],
  }),

  getStateTargetListValues: builder.query({
    query: (params) => ({
      url: `/state_targets/listAllValues`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["stateLevelMPRSCWelfareTarget"],
  }),
  getSaralApplicationDashboard: builder.query({
    query: (params) => ({
      url: `/ponds/saralApplicationStatusDashboard`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["saralApplicationStatusDashboard"],
  }),

  // ==============================FFStock_Seed=========================
  createFFStock: builder.mutation({
    query: (body) => ({
      url: `/fish_farm_stocks/create`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["FF_STOCK"],
  }),
  getFFStockList: builder.query({
    query: (params) => ({
      url: `fish_farm_stocks/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["FF_STOCK_LIST"],
  }),

  editFFStock: builder.query({
    query: (params) => ({
      url: `/fish_farm_stocks/edit`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_editPonds"],
  }),
  updateFFStock: builder.mutation({
    query: (body) => ({
      url: `/fish_farm_stocks/update`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["Farmer"],
  }),
  // getAllOrdersList: builder.mutation({
  //   query: (params) => ({
  //     url: `/fish_farm_stocks/allOrders`,
  //     method: "get",
  //     params: { ...params },
  //     headers: {
  //       Authorization: `Bearer ${getTokenFromLocalStorage()}`,
  //     },
  //   }),
  //   providesTags: ["All_orders"],
  // }),

  getAllOrdersList: builder.query({
    query: (params) => ({
      url: "/fish_farm_stocks/allOrders",
      method: "GET",
      params,
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["All_orders"],
  }),

  getFTypeList: builder.query({
    query: (params) => ({
      url: `/farmer/allFarmerTypes`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["F_Type"],
  }),

  getAllTrainingList: builder.query({
    query: (params) => ({
      url: `/creator/allTrainingTypes`,

      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),

    providesTags: ["All_Training_LIST"],
  }),

  getSaralApplicationStatusDashboardDistrictWaise: builder.query({
    query: (params) => ({
      url: `/ponds/saralApplicationStatusDashboardDistrictWaise`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["saralApplicationStatusDashboard"],
  }),
  getPvtPondExportedExcel: builder.query({
    query: (id) => ({
      url: `/ponds/exportPrivatePondsToXlsx?p_ownership=2`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),
  getWaterShedPondExportedExcel: builder.query({
    query: (id) => ({
      url: `/ponds/exportReservoirLakePondsToXlsx?p_ownership=3`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),
  getReservoirExportedExcel: builder.query({
    query: (id) => ({
      url: `/ponds/exportWatershedPondsToXlsx?p_ownership=4`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),
  getAllLookupList: builder.query({
    query: (params) => ({
      url: `/ponds/getAllLookups`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  createDBTRec: builder.mutation({
    query: (body) => ({
      url: `/dbt/add`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["DBT_STATE"],
  }),

  getDBTReports: builder.query({
    query: (params) => ({
      url: `/dbt/listing`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  getDBTById: builder.query({
    query: (id) => ({
      url: `/dbt/get/${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
  }),

  updateDBTRec: builder.mutation({
    query: (payload) => ({
      url: `/dbt/update`,
      method: "put",
      body: { ...payload },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    invalidatesTags: ["DBT_STATE"],
  }),
  getStateIntensiveAchievementsList: builder.query({
    query: (params) => ({
      url: `/ponds/stateLevelMPRIntensivechievemet`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["stateLevelMPRIntensivechievemet"],
  }),

  getStateAHDRAchievementsList: builder.query({
    query: (params) => ({
      url: `/view-reports/stateLevelMPRAHRDAchievemnt`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["stateLevelMPRAHRDAchievemnt"],
  }),

  createOrnamentalEntry: builder.mutation({
    query: (body) => ({
      url: `/ornamental-training-camp/create`,
      method: "post",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["POST_ORNAMENTAL_ENTRIES"],
  }),
  updateOrnamentalEntry: builder.mutation({
    query: (body) => ({
      url: `/ornamental-training-camp/updateEntry`,
      method: "put",
      body: { ...body },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["PUT_ORNAMENTAL_ENTRIES"],
  }),
  getOrnamentalEntryList: builder.query({
    query: (params) => ({
      url: `ornamental-training-camp/list`,
      method: "get",
      params: { ...params },
      headers: {
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    }),
    providesTags: ["GET_ORNAMENTAL_ENTRIES_LIST"],
  }),

});
